import { render, staticRenderFns } from "./PlanDetails.vue?vue&type=template&id=6360f5d1"
import script from "./PlanDetails.js?vue&type=script&lang=js&external"
export * from "./PlanDetails.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports